import { CircleAddIcon, GiftIcon, WithdrawalIcon } from 'assets/icons';
import cn from 'classnames';
import { OffersState } from 'features/offers/interface/store.interface';
import { selectHasAnyOffers } from 'features/offers/store/offers.selectors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Button from 'shared/components/form/button';
import { addNotification } from 'shared/components/toast';
import { AWAITING_ADMIN_APPROVAL, SectionNavigation } from 'shared/constants/common';
import { PaymentEvents } from 'shared/constants/datalayer';
import { useDeposit } from 'shared/hooks/useDeposit';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';
import { BalanceState, State } from 'shared/interface';
import { calcTotalBalance } from 'shared/util/utility';
import './styles.scss';
interface Props {
	onAction: (navType: typeof SectionNavigation.CP_PAYOUT | typeof SectionNavigation.CP_DEPOSIT) => void;
	handleRemoveOverflow: () => void;
	balanceData: BalanceState;
}

const FinancialOverview: React.FC<Props> = ({ onAction, handleRemoveOverflow, balanceData }) => {
	const { t } = useTranslation();
	const { mainBalance, bonusBalance } = balanceData;
	const { changeNavigationView } = useSectionNavigation();
	const hasAnyOffers = useSelector(selectHasAnyOffers);
	const { openDepositPanel } = useDeposit();
	const offers = useSelector<State, OffersState>((state) => state.offers);
	const { freebetsActive, bonusesQueued } = offers;
	const verificationStatus = useSelector<State, string>((state) => state.login.accountDetail?.account?.verificationStatus);
	const depositClickHandler = () => {
		PaymentEvents.DEPO_START({ depo_origin: ['panel gracza'] });
		openDepositPanel();
	};

	const payoutClickHandler = () => {
		if (verificationStatus === AWAITING_ADMIN_APPROVAL) {
			addNotification('warning', t('verificationPendingPayout'));
			return;
		}
		onAction(SectionNavigation.CP_PAYOUT);
		if (!!handleRemoveOverflow) {
			handleRemoveOverflow();
		}
	};
	const totalBalance = calcTotalBalance(mainBalance, bonusBalance, freebetsActive, bonusesQueued);

	return (
		<>
			<div className="FinancialOverview" data-cy="balance-display">
				<div className="FinancialOverview__totalBalance">
					<span className="FinancialOverview__title">{t('totalBalance')}</span>
					<span className="FinancialOverview__amount">{t('Common_currency', { val: totalBalance || 0 })}</span>
				</div>
				<div className="FinancialOverview__actions">
					<Button className="FinancialOverview__deposit" cyTestRef="cp-deposit" onClick={depositClickHandler}>
						<CircleAddIcon />
						{t('depositButton')}
					</Button>

					<div className="FinancialOverview__bottomSection">
						<div className="FinancialOverview__segment">
							<div className="FinancialOverview__sectionBackground" data-cy="cp-payout" onClick={payoutClickHandler}>
								<WithdrawalIcon className="FinancialOverview__icon" />
							</div>
							<span className="FinancialOverview__subTitle">{t('payoutButton')}</span>
						</div>
						<div className="FinancialOverview__segment">
							<div
								className={cn('FinancialOverview__sectionBackground', { 'FinancialOverview--indicator': hasAnyOffers })}
								data-cy="cp-payout"
								onClick={() => changeNavigationView(SectionNavigation.CP_BONUS)}
							>
								<GiftIcon className="FinancialOverview__icon" />
							</div>
							<span className="FinancialOverview__subTitle">{t('bonus')}</span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default FinancialOverview;
